import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import { axios } from "../../common";
import OptionHeaders from "../options";
import moment from "moment";
const { token, baseUrl, employeOid } = OptionHeaders();

const LEAVE_REGISTRATION_SHOW = "leave/showLeaveRegistration";
const LEAVE_REGISTRATION_DATA_SHOW = "leave/showLeaveRegistrationData";
const LEAVE_REGISTRATION_CREATE = "leave/createLeaveRegistration";
const LEAVE_REGISTRATION_CANCEL = "leave/cancelLeaveRegistration";
const LEAVE_SUMMARY_SHOW = "leave/showLeaveSummary";
const LEAVE_SUMMARY_SHOW_EMPLOYEE = "leave/showLeaveSummaryEmployee";
const LEAVE_APPROVAL_SHOW = "leave/showLeaveApproval";
const LEAVE_DECLARANT_SHOW = "leave/showLeaveDecalarant";
const LEAVE_SUMMARY_BY_EMPLOYEE_SHOW = "leave/showLeaveSummaryByEmployeeOid";
const LEAVE_REGISTRATION_BY_EMPLOYEE_SHOW =
  "leave/showLeaveRegistrationByEmployeeOid";

export const showLeaveRegistration = createAsyncThunk(
  LEAVE_REGISTRATION_SHOW,
  async (payload, thunkAPI) => {
    // const FromDate = moment(new Date(payload.FromDate)).format();
    // const ToDate = moment(new Date(payload.ToDate)).format();
    try {
      const { data } = await axios.get("LeaveRegistration", {
        params: {
          $expand: "Employee,Symbol",
          $filter:
            "Employee/Oid eq " +
            payload?.EmployeeOid +
            "" +
            " and FromDate ge " +
            payload.FromDate +
            "" +
            " and ToDate le " +
            payload.ToDate +
            "" +
            " and RequestStatus in [" +
            payload.Status.map((status) => `'${status}'`) +
            "]",
        },
         
          headers: {
            MappedState: 1,
          },
        
      });
      return data.value;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showLeaveRegistrationData = createAsyncThunk(
  LEAVE_REGISTRATION_DATA_SHOW,
  async (payload, thunkAPI) => {
    const FromDate = moment(new Date(payload.FromDate)).format();
    const ToDate = moment(new Date(payload.ToDate)).format();
    try {
      const leave = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}LeaveRegistrationData`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee,Symbol"],
        filter: [
          "Employee/Oid eq " +
            employeOid +
            "" +
            " and FromDate ge " +
            FromDate +
            "" +
            " and ToDate le " +
            ToDate +
            "" +
            " and RequestStatus in [" +
            payload.Status.map((status) => `'${status.toString(",")}'`) +
            "]",
        ],
      });
      return leave;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const createLeaveRegistration = createAsyncThunk(
  LEAVE_REGISTRATION_CREATE,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post(`LeaveRegistration`, payload, {
        headers: {
          MappedState: 2,
        },
      });
      return data.value;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getLeaveApproval = createAsyncThunk(
  LEAVE_APPROVAL_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("LeaveForApproval", payload, {
        headers: {
          MappedState: 1,
        },
      });
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getLeaveSummary = createAsyncThunk(
  LEAVE_SUMMARY_SHOW_EMPLOYEE,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get(`GetLeaveSummary(${payload})`, {
        headers: {
          MappedState: 1,
        },
      });
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getLeaveDeclarant = createAsyncThunk(
  LEAVE_DECLARANT_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("LeaveRegistrationDeclar", payload, {
        headers: {
          MappedState: 1,
        },
      });
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showLeaveSummary = createAsyncThunk(
  LEAVE_SUMMARY_SHOW,
  async (payload, thunkAPI) => {
    // const FromDate = moment(new Date(payload.FromDate)).format();
    // const ToDate = moment(new Date(payload.ToDate)).format();
    try {
      const leave = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}LeaveSummary`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee($expand=Department,Position)"],
        filter: [
          "Employee/Oid eq " + employeOid + " and Year eq " + payload.Year,
        ],
      });
      return leave;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showLeaveSummaryByEmployeeOid = createAsyncThunk(
  LEAVE_SUMMARY_BY_EMPLOYEE_SHOW,
  async (payload, thunkAPI) => {
    try {
      const leave = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}LeaveSummary`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee($expand=Department,Position)"],
        filter: ["Employee/Oid eq " + payload + ""],
      });
      return leave;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showLeaveRegistrationByEmployeeOid = createAsyncThunk(
  LEAVE_REGISTRATION_BY_EMPLOYEE_SHOW,
  async (payload, thunkAPI) => {
    try {
      const leave = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}LeaveRegistration`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee"],
        filter: ["Employee/Oid eq " + payload + ""],
      });
      return leave;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const cancelLeaveRegistration = createAsyncThunk(
  LEAVE_REGISTRATION_CANCEL,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post(`CancelRegistLeave`, payload, {
        headers: {
          MappedState: 4,
        },
      });
      return data.value;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
